<template>
  <b-container class="vertical-center">
    <div>
      <b-container class="vertical-center">
        <b-container style="margin-top:1%">
          <b-card title="Organic Growth FAQ"
                  sub-title="How to improve your LinkedIn Quality">
            <div role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-1 variant="info">LinkedIn
                    endorsements ?
                  </b-button>
                </b-card-header>
                <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text>LinkedIn endorsements are meant to provide credibility and
                      networking
                      opportunities.

                      Has LinkedIn ever notified you that someone has endorsed you for skills and
                      expertise that
                      have absolutely nothing to do with your actual skills? Or worse, you don’t
                      know
                      the
                      endorser at all, so how can he or she endorse any skills you have?

                      Sometimes people are endorsing you so you’ll see the notification and they’ll
                      be
                      on your
                      radar. Other times, people are endorsing you because they’re friends or
                      colleagues
                      and
                      they think they’re helping you.
                      <p>The right endorsements can increase your credibility. Help your friends and
                        colleagues choose the most relevant endorsements for you by using your
                        Skills
                        section and telling them what you’d like them to endorse.</p>
                      <p>Between 10% to 30% on your contact list will endorse you in return.</p>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-2 variant="info">Auto-Visit Profiles
                    to
                    get Look-Back !
                  </b-button>
                </b-card-header>
                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text>LinkedIn Auto-Visit give you the power to broadcast your profile,
                      and
                      encourage your network to look back to your profile,
                      <p>Between 40% to 30% on the visited profile will look back.</p>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-3 variant="info">Guess what's next ?
                  </b-button>
                </b-card-header>
                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      Stay Tuned with YourSynchronicity.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>

          </b-card>
        </b-container>
        <b-container>
          <b-row class="organic-class">
            <b-col>
              <AddNewYsyNodeLI/>
            </b-col>
            <b-col style="background-color: white">
              <card>
                <b-form class="Bform">
                  <div>
                    <label>How many Users do you want to endorse on this run</label>
                    <b-form-input id="usertoendorse" v-model="NbUsersToEndorse" type="range" min="0"
                                  max="200"></b-form-input>
                    <div class="mt-2">#Users: {{ NbUsersToEndorse }}</div>
                  </div>
                  <b-button v-if="triggerProcessEndorse" v-b-modal.modal-1 v-on:click="Endorse"
                            variant="primary">Auto-Endorse
                  </b-button>
                  <b-button v-else variant="primary" disabled>
                    <b-spinner small type="grow"></b-spinner>
                    On-going...
                  </b-button>
                  <b-modal id="modal-1" :header-bg-variant='headerBgVariant'
                           :header-text-variant="headerTextVariant"
                           title="YourSynchronicity Organic Growth"
                           ok-only>
                    <p class="my-4">Auto-Endorsement started you'll receive a report of the users
                      endorsed
                      and the skills that has been endorsed</p>
                  </b-modal>
                </b-form>
              </card>
            </b-col>
            <!--            <b-col style="background-color: white">-->
            <!--              <GetCompanyUrls/>-->
            <!--            </b-col>-->


          </b-row>
          <b-row class="organic-class">

            <!--            <b-col style="background-color: white"></b-col>-->
            <!--            <b-col style="background-color: white"></b-col>-->
          </b-row>
        </b-container>
      </b-container>
    </div>
  </b-container>
</template>

<script>
import {refreshIdToken} from '../../util/utilsYsy'
import addUserCredentials from "../addUserCredentials";
import AddNewYsyNodeLI from "@/components/ysy/AddNewYsyNodeLI";

export default {
  name: "EndorseLinkedInProfile",
  data() {
    return {
      triggerProcessEndorse: true,
      headerBgVariant: 'light',
      headerTextVariant: 'light',
      NbUsersToEndorse: 50,
    };
  },
  components: {
    AddNewYsyNodeLI,
    addUserCredentials,
  },

  methods: {
    refreshIdToken,
    async Endorse() {
      const path = this.BACKEND_YSY + "/linkedin/trigger-organic-growth";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      const payload = {
        email_linkedin: this.$store.getters.getEmailLinkedin,
        action_type: "endorse",
        nb_user_to_endorse: this.NbUsersToEndorse

      };
      this.triggerProcessEndorse = false;
      console.log(payload);
      // await this.$http
      //   .post(path, payload, {headers})
      //   .then(async res => {
      //     this.triggerProcessEndorse = false;
      //   })
      //   .catch(async error => {
      //     const self = this;
      //     if (error.response.status === 401) {
      //       console.error('Unauthorized', error.response.data);
      //       await this.refreshIdToken().then(function (result) {
      //         console.log("res promise", result); // "Stuff worked!"
      //         self.Endorse()
      //
      //       }, function (err) {
      //         console.log("it broke", err); // Error: "It broke"
      //         self.$router.push({name: 'login'});
      //       });
      //     }
      //   });
    }
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn
    },
    listen() {

    }

  }
  ,
  created() {

  },
  beforeDestroy() {

  },
}
</script>

<style scoped>

.btn {
  background-color: #33b5e5 !important;
}

.organic-class {
  max-height: 100%;
  max-width: 100%;
  height: 100%;
  /*background-color: black;*/
  padding: 10px;
  width: 100%;
}


</style>
